import {
  getFirestore,
  onSnapshot,
  doc,
  getDoc,
  getDocs,
  setDoc,
  updateDoc,
  collection,
  serverTimestamp,
  query,
  where,
  Timestamp,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { TYPES } from "./user.type";
import { REF } from "../ref";
import { app } from "../../config/config";

const firestore = getFirestore(app);
const auth = getAuth(app);

// -------------------------- Snapshot --------------------------
const authSub = [];
export const snapUser = (callback) => (dispatch) => {
  const cRef = collection(firestore, REF.USER);
  const uid = auth?.currentUser?.uid;
  const dRef = doc(cRef, uid);
  // snapshot
  const unSub = onSnapshot(dRef, (doc) => {
    const data = doc.data();
    getUserSuccess(dispatch, data);
    if (callback) {
      callback(data);
    }
  });
  authSub.push(unSub);
};

export const unSnapUser = () => (dispatch) => {
  authSub.forEach((subscriber) => {
    subscriber();
  });
  authSub.length = 0;
};

// -------------------------- Add User if not exist --------------------------

export const addUserInfo =
  ({ user }) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.USER);
    const uid = auth?.currentUser?.uid;
    const dRef = doc(cRef, uid);
    getDoc(dRef).then((doc) => {
      const data = doc.data();
      if (!data) {
        const email = user?.email || "";
        const firstName = user?.firstName || "";
        const lastName = user?.lastName || "";
        const password = user?.password || "";
        const phone = user?.phone || "";
        const ird = user?.ird || "";

        const info = {
          email,
          firstName,
          lastName,
          password,
          phone,
          id: uid,
          ird,
          createAt: serverTimestamp(),
        };
        setDoc(dRef, info, { merge: true });
      }
    });
  };

// -------------------------- Update User Info --------------------------
export const updateUserInfo =
  ({ update }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.USER);
    const uid = auth?.currentUser?.uid;
    const updated = {
      ...update,
      updateAt: serverTimestamp(),
    };
    const dRef = doc(cRef, uid);
    updateDoc(dRef, updated)
      .then(() => {
        if (callback) {
          callback({
            status: 200,
          });
        }
      })
      .catch((error) => {
        if (callback) {
          callback({
            status: 200,
            data: error?.message,
          });
        }
      });
  };

// ---------------- snap All user ---------------

export const getAllUser = (callback) => async (dispatch) => {
  try {
    getAllUserSuccess(dispatch, null);
    const cRef = collection(firestore, REF.USER);
    // const uid = auth?.currentUser?.uid;
    // const c0 = where("owner", "==", uid);
    // const qRef = query(cRef, c0);
    const snapshot = await getDocs(cRef);
    if (snapshot) {
      const data = snapshot?.docs?.map((doc) => doc.data());
      getAllUserSuccess(dispatch, data);
      if (callback) {
        callback();
      }
    }
  } catch (err) {
    console.log(err);
  }
};

// -------------------------- Dispatch --------------------------
const getUserSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.GET_USER_INFO_SUCCESS,
    payload: data,
  });
};

const getAllUserSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_ALL_USER_SUCCESS,
    payload: data,
  });
};

// ---------------- snap All user ---------------

let userSub = [];
export const snapAllUsers = (callback) => (dispatch) => {
  getUsersSuccess(dispatch, null);
  const cRef = collection(firestore, REF.USER);
  // const uid = auth?.currentUser?.uid;
  // const c0 = where("owner", "==", uid);
  // const qRef = query(cRef, c0);
  const qRef = query(cRef);
  // snapshot
  const unsub = onSnapshot(qRef, (snapshot) => {
    if (snapshot) {
      const data = snapshot.docs.map((doc) => doc.data());
      getUsersSuccess(dispatch, data);
      if (callback) {
        callback();
      }
    }
  });
  userSub.push(unsub);
};

export const unSnapUsers = () => (dispatch) => {
  userSub.forEach((subscriber) => {
    subscriber();
  });
  getUsersSuccess(dispatch, null);
  userSub.length = 0;
};

// -------------------------- Dispatch --------------------------
const getUsersSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_USERS_SUCCESS,
    payload: data,
  });
};

// -------------------------- update user by id --------------------------
export const updateUserById =
  ({ update, detail }, callback) =>
  (dispatch) => {
    const cRefUser = collection(firestore, REF.USER);
    const cRefStaff = collection(firestore, REF.STAFF);
    const staffId = detail?.id;
    const userId = detail?.id;

    //updateStaff
    const c0 = where("staff", "==", staffId);
    const qRef = query(cRefStaff, c0);
    getDocs(qRef)
      .then((snapshot) => {
        if (snapshot) {
          const data = snapshot.docs.map((doc) => doc.data());
          console.log(data);
          data.forEach((staff) => {
            const id = staff?.id;
            const dRefStaff = doc(cRefStaff, id);
            const active = update?.active;
            const updateAt = serverTimestamp();
            updateDoc(dRefStaff, { active, updateAt }).then(() => {});
          });
        }
      })
      .catch((err) => console.error(err));

    //update UserInfo
    const dRefInfo = doc(cRefUser, userId);
    // console.log({ update, userId });
    updateDoc(dRefInfo, update)
      .then(() => {
        if (callback) {
          callback({
            status: 200,
          });
        }
      })
      .catch((err) => {
        if (callback) {
          callback({
            status: 500,
            data: err,
          });
        }
      });
  };
